import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Loading, EmptyPageContent } from 'components/shared'
import { getRecents, resetRecents } from 'store/actions/global'
import { RecentCalls } from './components/RecentCalls'
import { RecentsImageSources } from './ImageSources'
import './Recents.scss'
import { useTranslation } from 'react-i18next'

export function Recents({ scrollContainerRef }) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const data = useSelector((state) => state.global.recentCallsData)
    const pagination = useSelector((state) => state.global.recentCallsPagination)
    const { loading, offset, hasMore, limit, period } = pagination

    useEffect(() => {
        dispatch(getRecents({ offset: 0, limit, period }))
        
        return () => {
            dispatch(resetRecents())
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onScroll = useCallback(() => {
        const scrollEl = scrollContainerRef?.current?.getScrollElement()

        const scrollPosition = scrollEl.offsetHeight + scrollEl.scrollTop
        const scrollEnd = scrollEl.scrollHeight - 3

        if (scrollPosition < scrollEnd) return
        
        if (!loading && hasMore) {
            dispatch(getRecents({ offset, limit, period }))
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [scrollContainerRef, offset, hasMore, loading, period])

    useEffect(() => {
        const scrollEl = scrollContainerRef?.current?.getScrollElement()
        scrollEl && scrollEl.addEventListener('scroll', onScroll)
        return () => {
            scrollEl && scrollEl.removeEventListener('scroll', onScroll)
        }
    }, [scrollContainerRef, onScroll])

    return (
        <>
            {!!data?.length && <RecentCalls recentCalls={data} />}
            {loading && <Loading />}
            {!loading && !data?.length && (
                <EmptyPageContent
                    pageTitle={t('navigation.recents')}
                    imgSrc={RecentsImageSources.emptyRecentsSrc}
                    messageLine1={t('no_recents')}
                    messageLine2={t('no_recents_msg')}
                    bgImageSrc={RecentsImageSources.emptyRecentsBgSrc}
                />
            )}
        </>
    )
}
